<template>
  <s-section is-sub-section>
    <template v-for="group in documents">
      <s-section
        :key="group.id"
        :is-sub-section="isSubSection"
        :title="group.title"
      >
        <template v-if="isSubSection">
          <div
            class="documents"
            :style="`grid-template-columns: repeat(${columns}, 1fr)`"
          >
            <template v-for="document in group.items">
              <s-document
                :key="document.id"
                :link="document.link"
              >
                <span v-html="document.title"></span>
              </s-document>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div
              class="documents col-xl-9 ml-auto"
              :style="`grid-template-columns: repeat(${columns}, 1fr)`"
            >
              <template v-for="document in group.items">
                <s-document
                  :key="document.id"
                  :link="document.link"
                >
                  <span v-html="document.title"></span>
                </s-document>
              </template>
            </div>
          </div>
        </template>
      </s-section>
    </template>
  </s-section>
</template>

<script>
export default {
  name: 'Documents',
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    columns: {
      type: String,
      default: '1'
    },
    isSubSection: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.documents {
  display: grid;
  grid-gap: 24px 16px;

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr !important;
  }
}
</style>